import Store from 'lightningjs-redux';

import { getContentAdvisory } from '../../../../logic/player/player.selectors';

const mapControllers = instance => ({
  contentAdvisory: {
    selector: getContentAdvisory,
    callback: value => {
      instance.contentAdvisory = value;
    },
  },
});

export default Store.control(mapControllers);
